export default __webpack_public_path__ + "img/main.discover-placeholder.24eff1d8.png";